<div [ngClass]="customClasses || 's2 m-t-1'"
     [innerHTML]="message | translate"></div>